// '订单状态：10-已创建；20-待发货；30-已发货|待收货；40-已完成；50-已取消'

export const statusIndexToText = {
  "10": "未采购",
  "20": "已采购",
};

export const statusTextToIndex = {
  "全部": "-1",
  "待发货": "0",
  "待收货": "1",
  "已完成": "2",
  "已取消": "3",
};

export const statusToButtons = {
  "15": "取消订单",
  "20": "取消订单",
  "30": "确认收货",
  // "2": "再来一单",
  // "3": "再次购买"
};

export const statusToButtonsConfirmed = {
  0: "确认收货",
  100: "订单完结",
  // "2": "再来一单",
  // "3": "再次购买"
};

export const showNumber = 3;